import {ValidationArguments, ValidatorConstraint, ValidatorConstraintInterface} from 'class-validator';

@ValidatorConstraint({name: 'matchesRegex', async: false})
class MatchesRegexConstraint implements ValidatorConstraintInterface {
	validate(value: string, args: ValidationArguments) {
		const [regex] = args.constraints;
		if (typeof regex !== 'string' || regex.length === 0) {
			return false; // אם regex אינו מחרוזת או ריק, החזר false
		}
		const pattern = new RegExp(regex);
		return pattern.test(value);
	}

	defaultMessage(args: ValidationArguments) {
		const [regex] = args.constraints;
		return `Value ($value) does not match the regular expression: ${regex}`;
	}
}
